<i-authentication [integration]="'component'" [applicationName]="'iDélibé'"
    [logoUrl]="'../../../assets/img/iDelibe.svg'" [subtitle]="subtitle" [description]="description"
    (onLogin)="login()" />